module.exports = (__webpack_require__(2))("./core/keyboard.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/keyboard.js from dll-reference base
// module id = 98
// module chunks = 22